export type CampaignQuoteTemplateModel = {
  agency_id: number,
  builder_version?: number,
  cache_key: number,
  campaign_id?: number,
  created_at: string,
  disable_custom_items?: boolean,
  disable_price_override?: boolean,
  disable_section_editing?: boolean,
  hidden?: boolean,
  id: number,
  title: string,
  total?: number,
  user_ids?: number[],
}

export type CampaignQuoteTemplateRequestOptions = {}

const state = {
  agency_id: undefined,
  builder_version: undefined,
  campaign_id: undefined,
  disable_custom_items: false,
  disable_price_override: false,
  disable_section_editing: false,
  hidden: false,
  id: null,
  title: '',
  total: 0,
  user_ids: [],
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'title' },
]

export default state
